import { ReactElement } from 'react';

import { Box, CSS, Flex } from '@project44/manifest-ds';

import { Breadcrumb, Breadcrumbs } from './Breadcrumbs';

interface Props {
  breadcrumbs: Breadcrumb[];
  children?: ReactElement;
  css?: CSS;
  hideSeperator?: boolean;
  colorMode?: 'brandBlue' | 'defaultBg';
  breadcrumbsCss?: CSS;
}

export type { Breadcrumb } from './Breadcrumbs';

export const BreadcrumbPageHeader = ({
  children,
  breadcrumbs,
  css,
  hideSeperator,
  colorMode = 'brandBlue',
  breadcrumbsCss,
}: Props) => {
  const isDefaultColorMode = colorMode === 'defaultBg';
  return (
    <Flex
      css={{
        backgroundColor: isDefaultColorMode
          ? '$background-primary'
          : '$background-top-nav',
        px: '$x-large',
        py: '$medium',
        ...css,
      }}
    >
      <Breadcrumbs
        crumbs={breadcrumbs}
        colorMode={isDefaultColorMode ? 'dark' : 'light'}
        css={breadcrumbsCss}
      />
      {children && !hideSeperator && (
        <Box
          css={{
            width: 1,
            height: 24,
            mx: '$medium',
            backgroundColor: '$text-tertiary',
            alignSelf: 'center',
          }}
        />
      )}
      {children}
    </Flex>
  );
};
